import React from 'react'
import { Link } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import V2Layout from '../components/V2Layout'

const ADMIN_PAGES = [
    {
        title: 'Product Catalog',
        description: 'Manage products, edit specifications, upload drawings, set categories, and configure technical filter values.',
        to: '/products/admin',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                <line x1="12" y1="22.08" x2="12" y2="12" />
            </svg>
        ),
        badge: 'Products'
    },
    {
        title: 'News & Press',
        description: 'Publish press releases, edit rich-text blog posts, manage status, and upload header images.',
        to: '/news/admin',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
            </svg>
        ),
        badge: 'Articles'
    },
    {
        title: 'Interactive Timeline',
        description: 'Update the company growth history lanes, add historical milestones, and edit equipment and facility footprint stats.',
        to: '/story/admin',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
            </svg>
        ),
        badge: 'Timeline'
    },
    {
        title: 'Certifications',
        description: 'Upload ISO/AS9100 quality certificates, set expiry dates, choose locations, and link PDFs.',
        to: '/certifications/admin',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <path d="M9 11l2 2 4-4" />
            </svg>
        ),
        badge: 'Standards'
    },
    {
        title: 'Capabilities Sections',
        description: 'Manage custom alternating text/image sections displayed on each of the Capabilities pages.',
        to: '/capabilities/admin',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
            </svg>
        ),
        badge: 'Capabilities'
    },
    {
        title: 'Company Statistics',
        description: 'Update global fleet metrics, lathe counts, facility size, cleanroom dimensions, and founding details across the website.',
        to: '/admin/stats',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="20" x2="18" y2="10" />
                <line x1="12" y1="20" x2="12" y2="4" />
                <line x1="6" y1="20" x2="6" y2="14" />
            </svg>
        ),
        badge: 'Settings'
    }
]

const AdminScreen = () => {
    return (
        <V2Layout pageClass="pfc-admin-dashboard">
            <section className="py-5" style={{ minHeight: 'calc(100vh - 380px)', background: 'var(--v2-bg-alt)' }}>
                <Container>
                    {/* Hero Header */}
                    <div className="admin-hero-card">
                        <h1 className="admin-hero-title">Management Console</h1>
                        <p className="admin-hero-sub">
                            Welcome to the Precision Fluid Controls administration panel. Select a module below to manage website databases, products, certifications, and timeline updates.
                        </p>
                    </div>

                    {/* Cards Grid */}
                    <div className="admin-cards-grid">
                        {ADMIN_PAGES.map(page => (
                            <Link to={page.to} key={page.to} className="admin-card" id={`admin-link-${page.badge.toLowerCase()}`}>
                                <span className="admin-card-badge">{page.badge}</span>
                                <div className="admin-card-icon-wrap">
                                    {page.icon}
                                </div>
                                <h3 className="admin-card-title">{page.title}</h3>
                                <p className="admin-card-desc">{page.description}</p>
                                <span className="admin-card-action">
                                    Open Module
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="5" y1="12" x2="19" y2="12" />
                                        <polyline points="12 5 19 12 12 19" />
                                    </svg>
                                </span>
                            </Link>
                        ))}
                    </div>
                </Container>
            </section>
        </V2Layout>
    )
}

export default AdminScreen
